import 'animate.css';
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './theme.css';
import NavBar from './components/NavBar';
import Exchange from './components/Exchange';
import FeatureCards from './components/FeatureCards';
import TransactionHistory from './components/TransactionHistory';
import CryptoTicker from './components/CryptoTicker';
import Terms from './components/Terms';
import Privacy from './components/Privacy';
import FAQ from './components/FAQ';
import RecentTransactions from './components/RecentTransactions';
import { Container, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldAlt, faBolt, faLock, faMoon, faSun } from '@fortawesome/free-solid-svg-icons';
import { faTelegram } from '@fortawesome/free-brands-svg-icons';
import './components/Exchange.css';
import './components/FeatureCards.css';
import './components/RecentTransactions.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  const [showLightning, setShowLightning] = useState(false);
  const [darkMode, setDarkMode] = useState(false);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLightning(true);
    }, 1500);
    
    return () => clearTimeout(timer);
  }, []);
  
  useEffect(() => {
    // Apply dark theme class to the document body
    if (darkMode) {
      document.body.classList.add('dark-theme');
    } else {
      document.body.classList.remove('dark-theme');
    }
  }, [darkMode]);

  return (
    <Router>
      <div className={`App ${darkMode ? 'dark-theme' : ''}`}>
        <NavBar />
        <div className="theme-toggle">
          <Button 
            variant="link" 
            className="theme-toggle-btn" 
            onClick={() => setDarkMode(!darkMode)}
            aria-label="Toggle theme"
          >
            <FontAwesomeIcon icon={darkMode ? faSun : faMoon} />
          </Button>
        </div>
        <CryptoTicker />
        <header className="App-header">
          <Container>
            <h1 className="animated-title">
              <span className="animate__animated animate__fadeInDown animate__faster">
                <span className="gradient-text">CryptoSwappie</span>
              </span>
              {showLightning && (
                <span className="lightning-emoji animate__animated animate__zoomIn animate__faster">
                  <i className="bi bi-lightning-charge-fill text-warning"></i>
                </span>
              )}
            </h1>
            <p className="App-subtitle animate__animated animate__fadeIn animate__delay-2s">
              Anonymous & Secure Cryptocurrency Exchange
            </p>
            <div className="hero-features animate__animated animate__fadeIn animate__delay-2s">
              <div className="hero-feature">
                <FontAwesomeIcon icon={faShieldAlt} />
                <span>Secure Transactions</span>
              </div>
              <div className="hero-feature">
                <FontAwesomeIcon icon={faBolt} />
                <span>Lightning Fast</span>
              </div>
              <div className="hero-feature">
                <FontAwesomeIcon icon={faLock} />
                <span>100% Anonymous</span>
              </div>
            </div>
          </Container>
        </header>
        <Routes>
          <Route path="/" element={
            <Container className="main-content">
              <Exchange />
              <FeatureCards showLightning={showLightning} />
              <RecentTransactions />
            </Container>
          } />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/transactions" element={<TransactionHistory />} />
        </Routes>
        
        <footer className="main-footer">
          <p className="copyright">&copy; 2023 CryptoSwappie❤️. All rights reserved.</p>
        </footer>
        <a
          href="https://t.me/Losemymind_9"
          target="_blank"
          rel="noopener noreferrer"
          className="telegram-float"
          aria-label="Join us on Telegram"
        >
          <FontAwesomeIcon icon={faTelegram} />
        </a>
      </div>
    </Router>
  );
}

export default App;
